/* eslint-disable */
import envIsProduction from '../../../Support/Env/IsProduction/EnvIsProduction.support';
import envIsTest from '../../../Support/Env/IsTest/EnvIsTest.support';
import isFunction from '../../../Support/Is/Function/IsFunction';

/**
 * Create a middleware that will log out actions but not the action creators
 * @returns {Middleware} The logger middleware
 */
const createLoggerMiddleware = () => {
  if (envIsProduction() || envIsTest()) {
    return () => (next) => (action) => next(action);
  }
  const { createLogger } = require(`redux-logger`); /* eslint-disable-line global-require */ // Only pull in the logger if need be
  return createLogger({
    collapsed: true,
    predicate: (getState, action) => {
      // Don't log the action creators
      if (isFunction(action)) {
        return;
      }
      return action; /* eslint-disable-line consistent-return */ // This is the intended behaviour
    },
  });
};

export default createLoggerMiddleware;
